import request from '@/utils/request'

export function getRole(data) {
    return request({
        url: '/webshop/api/gw/account/info',
        method: 'get',
        params: data
    })
}

export function loginOut() {
    return request({
        url: '/webshop/api/gw/account/loginOut',
        method: 'get',
    })
}

// 邮箱登录
export function emailLogin(data) {
    return request({
        url: '/webshop/api/oauth/login',
        method: 'post',
        data
    })
}
// 发送邮箱验证码
export function emailSendCode(data) {
    return request({
        url: '/webshop/api/oauth/emailSendCode',
        method: 'post',
        data
    })
}
// 重置邮箱密码
export function retrievePass(data) {
    return request({
        url: '/webshop/api/oauth/retrievePass',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/api/login.js